import React from 'react';

import ErrorPage404 from './ErrorPage404';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IErrorPage {}

const ErrorPage = () => <ErrorPage404 />;

export default ErrorPage;
